import React from 'react'
import Modal from 'react-bootstrap/Modal'

import ImageEdit from "../common/ImageEdit";
import AsyncSelect from "../common/AsyncSelect";

import Alert from "../alert/Alert";

import Notify from '../../../utils/Notify'
import Backend from "../../../utils/Backend";
import General from "../../../utils/General";

export default class TerminalModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      ...this._getState(props),
      show: props.show,
      loading: false,
      terminalUpdated: false,
      updatedStandaloneMode: false,
      error: null,
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this._getState(nextProps))
  }

  _getState(props) {
    return {
      ...props,
      terminal: props.terminal,
      currentStandaloneValue: props.terminal.standalone,
      data: {id: props.terminal.id},
    }
  }

  _isFormValid() {
    let { data, currentStandaloneValue } = this.state

    let error = null

    if(!currentStandaloneValue && data.standalone && !data.currency){
      error = "Please Select A Currency"
    }

    if (error) {
      Notify.error(error)
      return false
    }
    return true
  }

  _handleUpdate() {
    let { data } = this.state

    if (!this._isFormValid()) {
      return
    }

    Backend.updateTerminal(data).then(() => {
      Notify.success("Terminal Updated.")
      this.props.onSuccess(data)
    }).catch((e) => {
      Notify.error(e.message)
    })
  }

  render() {
    let {
      show,
      data,
      loading,
      error,
      terminal,
      terminalUpdated,
      currentStandaloneValue,
      updatedStandaloneMode
    } = this.state

    return (
      <Modal
        show={show}
        onHide={() => this.props.onHide()}
        dialogClassName={'modal-dialog-centered modal-lg'}
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Terminal</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {error && (
            <div className="form-group">
              <span className="error-message">{error}</span>
            </div>
          )}

          <div className="form-group row">
            <label className="col-3 col-form-label">Device Model</label>
            <div className="col-9">
              <input
                type="text"
                className="form-control form-control-solid"
                value={terminal.name}
                readOnly={true}
              />
            </div>
          </div>

          <div className="form-group row">
            <label className="col-3 col-form-label">Serial No</label>
            <div className="col-9">
              <input
                type="text"
                className="form-control form-control-solid"
                value={terminal.serial_no}
                readOnly={true}
              />
            </div>
          </div>

          <div className="form-group row">
            <label className="col-3 col-form-label">Logo</label>
            <div className="col-9">
              <ImageEdit
                image={terminal.logo}
                type="photo"
                hidePreview={false}
                onUpdated={(image) => {
                  terminal.logo = image
                  data.logo = image
                  this.setState({ data, terminal, terminalUpdated: true })
                }}
              />
            </div>
          </div>

          <div className="form-group row">
            <label className="col-3 col-form-label">Standalone Mode</label>
            <div className="col-9">
              <span className="switch switch-icon">
              <label>
                <input
                  type={"checkbox"}
                  checked={terminal.standalone}
                  onChange={e => {
                    terminal.standalone = e.target.checked
                    data.standalone = e.target.checked
                    this.setState({
                      data,
                      terminal,
                      terminalUpdated: true,
                      updatedStandaloneMode: true,
                    })
                  }}
                />
                <span></span>
              </label>
            </span>
            </div>
          </div>

          {
            (!currentStandaloneValue && updatedStandaloneMode) && terminal.standalone && (
              <div className="form-group row">
                <label className="col-3 col-form-label">Currency</label>
                <div className="col-9">
                  <AsyncSelect
                    endpoint={window.Api.Currencies}
                    className={'custom-async-select__container'}
                    classNamePrefix={'custom-async-select'}
                    params={{}}
                    placeholder="Select A Currency"
                    value={terminal.currency ? General.getSingleAsyncOption(terminal.currency) : null}
                    onSelected={currency => {
                      data.currency = currency
                      terminal.currency = currency
                      this.setState({ data, terminal, terminalUpdated: true })
                    }}
                    getOptions={currencies => General.getAsyncOptions(currencies)}
                  />
                </div>
              </div>
            )
          }

          {
            (currentStandaloneValue && updatedStandaloneMode) && !terminal.standalone && (
              <Alert
                text={"Turning Off Standalone Mode Will Cause The Terminal To Stop Working."}
                closable={false}
              />
            )
          }

        </Modal.Body>

        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary font-weight-bold"
            onClick={() => this.props.onHide()}
          >
            Cancel
          </button>

          <button
            type="button"
            className="btn btn-primary font-weight-bold"
            id="add-success"
            disabled={loading || !terminalUpdated}
            onClick={() => this._handleUpdate()}
          >
            <span className="svg-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
              >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <polygon points="0 0 24 0 24 24 0 24"></polygon>
                  <path
                    d="M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z"
                    fill="#000000"
                    fillRule="nonzero"
                    transform="translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002) "
                  ></path>
                </g>
              </svg>
            </span>
            Update
          </button>
        </Modal.Footer>
      </Modal>
    )
  }
}
